import { Box, Typography } from "@mui/material";

export const FileDetailsNoFileType = () => {
  return (
    <Box p={2}>
      <Typography variant="subtitle1">Waiting for files</Typography>
    </Box>
  );
};
